export const transformFeatureRecord = ({
  feature,
  apiName
}) => {
  return {
    shortName: feature.shortName,
    name: feature.displayName,
    description: apiName ? feature.descriptions[apiName] : null,
    shortLimit: apiName ? feature.shortLimits[apiName] : null,
    longLimit: apiName ? feature.longLimits[apiName] : null
  };
};
export const transformGrowthFeature = ({
  feature
}) => {
  return {
    shortName: feature.shortName,
    name: feature.displayName,
    description: feature.defaultDescription,
    shortLimit: null,
    longLimit: null
  };
};
export const transformFeatureRecordWithDefaults = ({
  feature,
  productLevel
}) => {
  return {
    shortName: feature.shortName,
    name: feature.displayName,
    description: feature.description,
    shortLimit: productLevel ? feature.shortLimits[productLevel] : null,
    longLimit: productLevel ? feature.longLimits[productLevel] : null
  };
};